import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('../views/Home.vue')
    },
    // 系统管理
    {
      path: '/admin/user',
      name: 'AdminUser',
      component: () => import('../views/admin/AdminUser.vue')
    },
    {
      path: '/admin/role',
      name: 'AdminRole',
      component: () => import('../views/admin/AdminRole.vue')
    },
    {
      path: '/admin/permission',
      name: 'AdminPermission',
      component: () => import('../views/admin/AdminPermission.vue')
    },
    // 用户管理
    {
      path: '/user/list',
      name: 'UserList',
      component: () => import('../views/user/UserList.vue')
    },
    {
      path: '/user/message',
      name: 'UserMessage',
      component: () => import('../views/user/UserMessage.vue')
    },
    {
      path: '/user/vip-order',
      name: 'VipOrderList',
      component: () => import('../views/user/VipOrderList.vue')
    },
    // 内容管理
    {
      path: '/content/record',
      name: 'RecordList',
      component: () => import('../views/content/RecordList.vue')
    },
    {
      path: '/content/relation',
      name: 'RelationList',
      component: () => import('../views/content/RelationList.vue')
    },
    {
      path: '/content/square',
      name: 'SquareList',
      component: () => import('../views/content/SquareList.vue')
    },
    {
      path: '/content/love-pk',
      name: 'LovePkList',
      component: () => import('../views/content/LovePkList.vue')
    },
    {
      path: '/content/love-pk-theme',
      name: 'LovePkThemeList',
      component: () => import('../views/content/LovePkThemeList.vue')
    },
    {
      path: '/content/feedback',
      name: 'FeedbackList',
      component: () => import('../views/content/FeedbackList.vue')
    },
    {
      path: '/content/barrage',
      name: 'BarrageList',
      component: () => import('../views/content/BarrageList.vue')
    },
    {
      path: '/content/gift',
      name: 'GiftList',
      component: () => import('../views/content/GiftList.vue')
    },
    // 数据统计
    {
      path: '/stats/emotion',
      name: 'EmotionStats',
      component: () => import('../views/stats/EmotionStats.vue')
    },
    {
      path: '/stats/user',
      name: 'UserStats',
      component: () => import('../views/stats/UserStats.vue')
    },
    {
      path: '/stats/content',
      name: 'ContentStats',
      component: () => import('../views/stats/ContentStats.vue')
    }
  ]
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('adminToken')
  const requiresAuth = to.path !== '/'
  
  if (requiresAuth && !token) {
    next('/')
  } else {
    next()
  }
})

export default router